export const countNotifications: Array<string> = [
  '5',
  '10',
  '15',
  '20',
  '25',
  '30',
  '35',
  '40',
  '45',
  '50',
  '55',
  '60',
  '70',
  '80',
  '90',
  '100',
];



// WEBPACK FOOTER //
// ./src/pages/profile/modules/notification/consts.ts